"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const typography_1 = __importDefault(require("../../elements/typography"));
const Accordion = (props) => {
    const { size = "medium", clickAttribute, title, titleColor = "text.secondary", subtitle, children, actions, defaultOpen = false, isExpanded, disabled = false, sx = {}, onChangeIsExpanded, } = props;
    const [expanded, setExpanded] = (0, react_1.useState)(defaultOpen);
    const handleChange = (e, newExpanded) => {
        if (typeof onChangeIsExpanded === "function") {
            onChangeIsExpanded(newExpanded);
        }
        else {
            setExpanded(newExpanded);
        }
    };
    return (react_1.default.createElement(material_1.Accordion, { square: false, expanded: typeof isExpanded === "boolean" ? isExpanded : expanded, disabled: disabled, sx: { backgroundColor: colors_1.default.secondary[700], ...sx }, onChange: handleChange },
        react_1.default.createElement(material_1.AccordionSummary, { expandIcon: react_1.default.createElement(iconoir_react_1.NavArrowDown, { style: { color: colors_1.default.icons[700] } }) },
            title && (react_1.default.createElement(typography_1.default, { variant: "body2", color: titleColor, sx: { display: "flex", alignItems: "center", flex: 1 } }, (0, html_react_parser_1.default)(`${title}`))),
            subtitle && (react_1.default.createElement(typography_1.default, { variant: "body2", sx: { display: "flex", alignItems: "center", px: 2, color: colors_1.default.text[700] } }, (0, html_react_parser_1.default)(subtitle))),
            react_1.default.createElement(material_1.Box, { sx: { display: "flex", flexDirection: "row" } }, actions && (react_1.default.createElement(material_1.Stack, { direction: "row", gap: 0.5 }, actions
                .filter((action) => action.icon && action.onClick)
                .map(({ icon, tooltip, onClick }, actionsIndex) => {
                const button = (react_1.default.createElement(material_1.IconButton, { onClick: (e) => {
                        e.stopPropagation();
                        onClick(title, clickAttribute);
                    }, size: "small", sx: {
                        fontSize: "0.9rem",
                        color: titleColor === "text.secondary" ? colors_1.default.icons[700] : colors_1.default.icons[100],
                    } }, icon));
                return (react_1.default.createElement(react_1.Fragment, { key: actionsIndex }, tooltip ? (react_1.default.createElement(material_1.Tooltip, { title: tooltip, disableInteractive: true }, button)) : (button)));
            }))))),
        react_1.default.createElement(material_1.AccordionDetails, { sx: { p: size === "small" ? 1.5 : 2.5 } }, children)));
};
exports.default = Accordion;
